const categories = [
    {
        id: 1,
        domain: "Artificial Intelligence",
        image: 'https://venturebeat.com/wp-content/uploads/2018/05/ai-machine_learning-shutterstock_671158525.jpg'
    },
    {
        id: 2,
        domain: "Machine Learning",
        image: 'https://th.bing.com/th/id/OIP.u1LY35FRcTfmIpp7X-UkiAHaE7?rs=1&pid=ImgDetMain'
    },
    {
        id: 3,
        domain: "Web Development",
        image: 'https://www.danielhonrade.com/wp-content/uploads/2020/09/Web-development-1.jpg'
    },
    {
        id: 4,
        domain: "Quantum Computing",
        image: 'https://venturebeat.com/wp-content/uploads/2018/05/ai-machine_learning-shutterstock_671158525.jpg'
    },
    {
        id: 5,
        domain: "Signal Processing",
        image: 'https://venturebeat.com/wp-content/uploads/2018/05/ai-machine_learning-shutterstock_671158525.jpg'
    },
    {
        id: 5,
        domain: "Signal Processing",
        image: 'https://venturebeat.com/wp-content/uploads/2018/05/ai-machine_learning-shutterstock_671158525.jpg'
    },
    {
        id: 5,
        domain: "Signal Processing",
        image: 'https://venturebeat.com/wp-content/uploads/2018/05/ai-machine_learning-shutterstock_671158525.jpg'
    },
    {
        id: 5,
        domain: "Signal Processing",
        image: 'https://venturebeat.com/wp-content/uploads/2018/05/ai-machine_learning-shutterstock_671158525.jpg'
    },
    {
        id: 5,
        domain: "Signal Processing",
        image: 'https://venturebeat.com/wp-content/uploads/2018/05/ai-machine_learning-shutterstock_671158525.jpg'
    },
    {
        id: 5,
        domain: "Signal Processing",
        image: 'https://venturebeat.com/wp-content/uploads/2018/05/ai-machine_learning-shutterstock_671158525.jpg'
    }
];

export default categories
